export enum HFR_HPR_MIXPANEL_EVENTS {
  CREATE_HFR_PAGE_VIEW = "CREATE_HFR_PAGE_VIEW",
  GENERATE_AADHAAR_OTP_PAGE_VIEW = "GENERATE_AADHAAR_OTP_PAGE_VIEW",
  VERIFY_AADHAAR_OTP_PAGE_VIEW = "VERIFY_AADHAAR_OTP_PAGE_VIEW",
  CREATE_HPR_PAGE_VIEW = "CREATE_HPR_PAGE_VIEW",
  AADHAAR_MOBILE_VERIFY_PAGE_VIEW = "AADHAAR_MOBILE_VERIFY_PAGE_VIEW",
  GET_AADHAR_OTP = "HPR_GET_AADHAR_OTP",
  RESEND_AADHAR_OTP = "HPR_RESEND_AADHAR_OTP",
  SUBMIT_AADHAR_OTP = "HPR_SUBMIT_AADHAR_OTP",
  VERIFY_PHONE = "HPR_VERIFY_PHONE",
  INIT_CREATE_HFR = "HFR_START",
  CREATE_HFR = "CREATE_HFR",
  LINK_HFR = "LINK_HFR",
  CREATE_HPR = "HPR_CREATE_HPRID",
  HFR_HPR_EXIST_CHECK_SUCCESS = "HFR_HPR_EXIST_CHECK_SUCCESS",
  HFR_HPR_EXIST_CHECK_FAILURE = "HFR_HPR_EXIST_CHECK_FAILURE",
}
